import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TsplatFallSmoothIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 3C2.23001 3 0.0900088 19.19 8.77772e-06 19.88C-0.0699912 20.43 0.320009 20.93 0.870009 21C1.42001 21.06 1.92001 20.68 1.99001 20.13C2.01001 19.98 3.99001 5.01 12 5.01C20.01 5.01 21.99 19.98 22.01 20.13C22.07 20.64 22.5 21.01 23 21.01C23.04 21.01 23.08 21.01 23.12 21.01C23.67 20.94 24.06 20.44 23.99 19.89C23.9 19.2 21.77 3.01 12 3.01V3Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TsplatFallSmoothIcon.displayName = 'TsplatFallSmoothIcon';
